module.exports = __webpack_public_path__ + "static/small_zulu-fa271442ff1b36373a91c1549cefb015.jpg";